import { JuloUpdateEntry } from "./types"

export const vantarPaDelEntry: JuloUpdateEntry = {
  slug: "2026-05-07-vantar-pa-del",
  date: "2026-05-07",
  title: "”Väntar på del” är nu en egen status",
  description:
    "Tidigare visades jobb som väntar på del bland era andra statusar med en separat liten markering. Nu är ”Väntar på del” en egen status med en egen flik på översikten och en egen brun-orange färg på jobbkortet, så att ni snabbt ser vilka jobb som ligger och väntar på en leverans. Jobben försvinner samtidigt från övriga statusflikar tills delen kommit in, och filtret ”Dölj jobb som väntar på leverans” är därför borttaget.",
  images: [
    {
      src: "/julo-updates/2026-05-07-vantar-pa-del/oversikt.png",
      alt: "Översikten med den nya ”Väntar på del”-fliken markerad i sidopanelen och en lista med jobb där statusen visas som en brun-orange ”Väntar på del”-bricka på varje jobbkort.",
    },
  ],
}
